<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__grid">
        <!-- Left: Logo + Contact -->
        <section class="footer__left">
          <router-link to="/home" class="footer__logoLink" aria-label="AiLife Home">
            <!-- 直接使用白色logo：去掉蓝色卡片背景 -->
            <el-image src="https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/logo2.png" fit="contain" class="footer__logoImg footer__logoImg--plain" alt="AiLife Diagnostics">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </router-link>

          <div class="footer__contact">
            <div class="footer__h">Contact Us</div>

            <div class="footer__info">
              <div class="footer__infoRow">
                <i class="el-icon-location-outline"></i>
                <div>1920 Country Pl Pkwy, Suite 100, Pearland, TX 77584</div>
              </div>

              <div class="footer__infoRow">
                <i class="el-icon-phone-outline"></i>
                <a class="footer__a" href="tel:+13463421802">(346) 342-1802</a>
              </div>

              <div class="footer__infoRow">
                <i class="el-icon-message"></i>
                <a class="footer__a" href="mailto:contact@ailifeus.com">contact@ailifeus.com</a>
              </div>

              <div class="footer__infoRow">
                <i class="el-icon-time"></i>
                <div>
                  <div class="footer__k">Client Services</div>
                  <div class="footer__v">8:30 am—5:30 pm CDT, Monday—Friday</div>
                </div>
              </div>

              <div class="footer__infoRow">
                <i class="el-icon-time"></i>
                <div>
                  <div class="footer__k">Sample Receiving</div>
                  <div class="footer__v">8:30 am—5:30 pm CDT, Monday—Saturday</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Right: Link Columns -->
        <section class="footer__cols">
          <!-- Test Menu（保留，但删除 Repeat Expansion Disorders） -->
          <!-- <div class="footer__col">
            <div class="footer__title">Test Menu</div>
            <ul class="footer__list">
              <li><router-link class="footer__link" to="/products/wgs">Whole Genome Sequencing</router-link></li>
              <li><router-link class="footer__link" to="/products/wes">Whole Exome Sequencing</router-link></li>
              <li><router-link class="footer__link" to="/products/clinical">Clinical Specialties</router-link></li>
            </ul>
          </div> -->

          <div class="footer__col">
            <div class="footer__title">Test Menu</div>
            <ul class="footer__list">
              <li><router-link class="footer__link" to="/test/WholeGenomeSequencingProbandOnly">Whole Genome Sequencing</router-link></li>
              <li><router-link class="footer__link" to="/test/WholeExomeSequencingProbandOnly">Whole Exome Sequencing</router-link></li>
              <li><router-link class="footer__link" to="/test/category/audiology">Clinical Specialties</router-link></li>
            </ul>
          </div>

          <!-- About Us：加入 Careers，并放在 Our Licenses 下 -->
          <div class="footer__col">
            <div class="footer__title">About Us</div>
            <ul class="footer__list">
              <li><router-link class="footer__link" to="/about/mission">Our Mission</router-link></li>
              <li><router-link class="footer__link" to="/about/licenses">Our Licenses</router-link></li>
              <!-- Careers moved here; landing to /join -->
              <li><router-link class="footer__link" to="/join">Careers</router-link></li>
              <!-- <li><router-link class="footer__link" to="/join">Our People</router-link></li> -->
              <li><router-link class="footer__link" to="/about/privacy">Privacy Policy</router-link></li>
            </ul>
          </div>
        </section>
      </div>

      <div class="footer__bottom">
        <div class="footer__copyright">
          © {{ new Date().getFullYear() }} AiLife Diagnostics. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footerBase",
  data() {
    return {
      // TODO: 换成你的白色logo链接（最好是透明背景 PNG/SVG）
      WHITE_LOGO_URL: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/AiLifeLogo_white.png",
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #2b63b6;
  color: rgba(255, 255, 255, 0.9);
}

.footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 42px 18px 18px;
}

/* 栅格两栏：左信息、右链接 */
.footer__grid {
  display: grid;
  grid-template-columns: 380px 1fr;
  gap: 44px;
  align-items: start;
}

/* 左侧 */
.footer__left {
  display: grid;
  gap: 18px;
}

.footer__logoLink {
  display: inline-flex;
  align-items: center;
}

/* ✅ 去掉原来的 footer__logoCard（不再需要） */
/* 新的“纯logo”样式 */
.footer__logoImg--plain {
  width: 220px;
  height: 88px;
  display: block;
}

/* Contact */
.footer__h {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.3px;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.95);
}

.footer__info {
  display: grid;
  gap: 12px;
}

.footer__infoRow {
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 10px;
  align-items: start;
  font-size: 13px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.85);
}

.footer__infoRow i {
  margin-top: 3px;
  opacity: 0.85;
}

.footer__k {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.92);
}
.footer__v {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.82);
  font-variant: normal;
}

.footer__a {
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
}
.footer__a:hover {
  text-decoration: underline;
}

/* 右侧链接列（现在只剩两列内容，但布局保持弹性） */
.footer__cols {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px 34px;
}

.footer__title {
  font-size: 14px;
  font-weight: 800;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.95);
}

.footer__list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer__list li {
  margin: 9px 0;
  font-size: 13px;
  line-height: 1.7;
}

.footer__link {
  color: rgba(255, 255, 255, 0.82);
  text-decoration: none;
}
.footer__link:hover {
  color: rgba(255, 255, 255, 0.98);
  text-decoration: underline;
}

/* bottom */
.footer__bottom {
  margin-top: 28px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  justify-content: center;
}
.footer__copyright {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  text-align: center;
}

/* 平板 */
@media (max-width: 1024px) {
  .footer__grid {
    grid-template-columns: 1fr;
    gap: 26px;
  }
  .footer__cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px 26px;
  }
}

/* 手机 */
@media (max-width: 640px) {
  .footer__cols {
    grid-template-columns: 1fr;
  }
  .footer__logoImg--plain {
    width: 190px;
    height: 78px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Footer/footer.vue